import { Navigate, useRoutes } from 'react-router-dom';
// config
import { PATH_AFTER_LOGIN } from 'src/config-global';

//
import { mainRoutes } from './common';
import { loginRequiredRoutes } from './login-required';
import { logoutRequiredRoutes } from './logout-required';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // TODO:⭐️로그인 안한 상태에서 root 접근할 경우 대응 필요함.
    {
      path: '/',
      element: <Navigate to={PATH_AFTER_LOGIN} replace />
    },

    // Logout required routes
    ...logoutRequiredRoutes,

    // Login required routes
    ...loginRequiredRoutes,

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
